import NavigationRail from './navigation-rail';

export default NavigationRail;